import { Store as StoreModel } from '@core/models';
import { StoreScheduleRange } from '../interfaces';
import { checkStoreStatus } from './store-status.domain';

/**
 * Retrieves the opening and closing hours for a store by order type code and day of week.
 */
export function getStoreScheduleRange(
	store: StoreModel,
	code: string,
	referenceDate: Date = new Date()
): StoreScheduleRange | null {
	const today = referenceDate.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();

	const deliveryOrderType = store.order_type?.find(orderType => orderType.codigo === code);
	if (!deliveryOrderType) {
		return null;
	}

	const orderOlo = deliveryOrderType.canales?.find(
		channel => !!channel?.configuracion?.diasAsociados
	)?.configuracion;
	if (!orderOlo || !orderOlo.diasAsociados) {
		return null;
	}

	const todayConfig = orderOlo.diasAsociados.find(
		day => (day.nombreDia || '').toLowerCase() === today
	);
	if (!todayConfig || !todayConfig.horaInicio || !todayConfig.horaFin) {
		return null;
	}

	return {
		apertura: todayConfig.horaInicio,
		cierre: todayConfig.horaFin,
	};
}

/**
 * Resolves the relevant schedule time text based on store availability and configuration.
 */
export function getStoreScheduleTime(
	store: StoreModel,
	code: string,
	isAvailable: boolean,
	referenceDate: Date = new Date()
): string {
	const range = getStoreScheduleRange(store, code, referenceDate);
	if (isAvailable && range?.apertura) {
		return range.apertura;
	}
	if (!isAvailable && range?.cierre) {
		return range.cierre;
	}
	const status = checkStoreStatus(store.horarios ?? [], referenceDate);
	return status.nextChange;
}
